export async function fetchData(url) {
    const response = await fetch(url);
    return response.json();
}
//# sourceMappingURL=api.js.map